interface BadgeProps {
  children: React.ReactNode
  className?: string
  dot?: string
}

export default function Badge({children, className = '', dot}: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-semibold leading-none whitespace-nowrap ${className}`}
    >
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />}
      {children}
    </span>
  )
}

interface LabelBadgeProps {
  name: string
  color: string
}

export function LabelBadge({name, color}: LabelBadgeProps) {
  return (
    <span
      className='inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium text-white'
      style={{backgroundColor: color}}
    >
      {name}
    </span>
  )
}
